import { useEffect, useState } from 'react';

import api from '@src/api/clients';
import {
  Box, Card, CardContent, CardHeader, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress
} from '@mui/material';

export default function BackendDataSummaryPage() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api
      .request({ url: 'dashboard/client-backend-summary/', method: 'GET' })
      .then(res => setRows(res.data))
      .catch(console.error);
  }, []);

  if (rows === null) {
    return <Box textAlign="center"><CircularProgress/></Box>;
  }

  return (
    <Card>
      <CardHeader title="Backend Data Summary by Client" />
      <CardContent>
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Client</TableCell>
                  <TableCell>Last Updated</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Set</TableCell>
                <TableCell>Issues</TableCell>
                <TableCell>Demos</TableCell>
                <TableCell>Gross Sold</TableCell>
                <TableCell>Net Sold</TableCell>
                <TableCell>Gross Amount</TableCell>
                <TableCell>Net Amount</TableCell>
              </TableRow>
            </TableHead>
                <TableBody>
                {rows.map(r => (
                    <TableRow key={r.client_id}>
                    <TableCell>{r.client__name}</TableCell>
                    <TableCell>{new Date(r.last_updated).toLocaleString()}</TableCell>
                    <TableCell>{r.total_records}</TableCell>
                    <TableCell>{r.appointment_count}</TableCell>
                    <TableCell>{r.issue_count}</TableCell>
                    <TableCell>{r.demo_count}</TableCell>
                    <TableCell>{r.sold_count}</TableCell>
                    <TableCell>{r.net_amount_count}</TableCell>
                    <TableCell>
                        {r.gross_amount_sum != null
                        ? Number(r.gross_amount_sum).toLocaleString('en-US', {
                             style: 'currency',
                            currency: 'USD',
                            })
                        : '-'}
                    </TableCell>
                    <TableCell>
                        {r.net_amount_sum != null
                        ? Number(r.net_amount_sum).toLocaleString('en-US', {
                            style: 'currency',
                            currency: 'USD',
                            })
                        : '-'}
                    </TableCell>
                    </TableRow>
                ))}
                </TableBody>


          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}
